import { AxiosResponse } from 'axios';
import baseService from 'services/base-service';
import { ApiResponseModel } from 'models/api';
import { ISubscribeDeviceModel } from 'models/notification/subscribe-device';

const endPointBaseURL = `patients/SubscribeDevice`;

const addEditSubscribeDevice = async (
    requestBody: ISubscribeDeviceModel,
): Promise<AxiosResponse<ApiResponseModel<number>>> =>
    baseService.post<ApiResponseModel<number>>(`${endPointBaseURL}/AddEditSubscribeDevice`, requestBody);

const subscribeDeviceDelete = async (userId: string): Promise<AxiosResponse<ApiResponseModel<number>>> =>
    baseService.post<ApiResponseModel<number>>(`${endPointBaseURL}/SubscribeDeviceDelete?userId=${userId}`);

export default {
    addEditSubscribeDevice,
    subscribeDeviceDelete,
};
